/* ============================================================
   OBF Cart Drawer — interactions (Solstice)
   - Upsell loader (fills <obf-recs> from its data-url) + arrows
   - Quick add from upsell → opens variant picker (color + size)
   - Variant change / add modal: image gallery, highlighted price,
     all colors visible, sticky Save button
   - Rotating reviews (auto + manual arrows)
   Loaded once; all handlers are document-delegated so they survive
   the drawer's server-side re-renders.
   ============================================================ */
(function () {
  if (window.__obfCartDrawerJsInit) return;
  window.__obfCartDrawerJsInit = true;

  /* ── Rotating reviews ── */
  function initCartReviews() {
    var box = document.querySelector('#Cart-Drawer .obf-reviews');
    if (!box) return;
    var slides = box.querySelectorAll('.obf-review');
    if (!slides.length) return;
    var idx = 0;
    for (var k = 0; k < slides.length; k++) { if (slides[k].classList.contains('is-active')) idx = k; }
    box.__obfIdx = idx;
    box.__obfShow = function (n) {
      n = (n + slides.length) % slides.length;
      slides[box.__obfIdx].classList.remove('is-active');
      slides[n].classList.add('is-active');
      box.__obfIdx = n;
    };
    if (box.__obfTimer) clearInterval(box.__obfTimer);
    if (slides.length > 1) {
      box.__obfTimer = setInterval(function () { box.__obfShow(box.__obfIdx + 1); }, 4500);
    }
  }

  /* ── Upsell carousel arrows (show/hide on overflow) ── */
  function initRecNav() {
    document.querySelectorAll('#Cart-Drawer .obf-recs__viewport').forEach(function (vp) {
      var track = vp.querySelector('.obf-recs__track');
      var prev = vp.querySelector('.obf-recs__nav--prev');
      var next = vp.querySelector('.obf-recs__nav--next');
      if (!track) return;
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        var can = max > 2;
        if (prev) prev.hidden = !can || track.scrollLeft <= 2;
        if (next) next.hidden = !can || track.scrollLeft >= max;
      };
      vp.__obfRecUpd = upd;
      if (!track.__obfNavBound) {
        track.__obfNavBound = true;
        track.addEventListener('scroll', upd, { passive: true });
      }
      upd();
    });
  }

  function initCartDrawerWidgets() { initCartReviews(); initRecNav(); }
  window.initCartDrawerWidgets = initCartDrawerWidgets;

  /* ── Upsell loader: fill <obf-recs> from its data-url ── */
  window.initRecommendationTracks = function () {
    initCartDrawerWidgets();
    document.querySelectorAll('obf-recs[data-url]').forEach(function (el) {
      if (el.dataset.obfLoaded === '1' || el.dataset.obfLoading === '1') return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      el.dataset.obfLoading = '1';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('obf-recs');
          if (fresh) el.innerHTML = fresh.innerHTML;
          el.dataset.obfLoaded = '1';
          el.dataset.obfLoading = '';
          initCartDrawerWidgets();
        })
        .catch(function () { el.dataset.obfLoading = ''; });
    });
  };

  /* Re-render the whole drawer body from the server section. */
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var inner = new DOMParser()
          .parseFromString(data['cart-drawer'], 'text/html')
          .querySelector('#Cart-Drawer .side-panel-inner');
        if (inner) {
          document.querySelector('#Cart-Drawer .side-panel-inner').innerHTML = inner.innerHTML;
          if (window.initRecommendationTracks) window.initRecommendationTracks();
        }
      });
  }

  /* ── Direct add (single-variant upsell only) ── */
  function directAdd(vid, btn) {
    if (!vid) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(refreshDrawer)
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  /* ── Variant change / add modal ── */
  var vm = { mode: 'change', itemKey: null, qty: 1, variants: [], options: [], colorIdx: -1, colorImg: {}, images: [], manualImg: null, selected: {}, selectedId: null, baseTitle: '', baseImage: '', props: null, isGift: false };

  function money(a) { return '$' + ((a || 0) / 100).toFixed(2); }

  function imgOf(v) {
    if (!v) return '';
    var f = v.featured_image || v.image;
    if (!f) return '';
    if (typeof f === 'string') return f;
    return f.src || f.url || '';
  }

  function imgKey(u) { return (u || '').split('?')[0].split('/').pop(); }
  function sameImg(a, b) { var ka = imgKey(a); return ka !== '' && ka === imgKey(b); }

  function normaliseProps(p) {
    if (!p) return null;
    var out = {};
    if (Array.isArray(p)) {
      p.forEach(function (pair) { if (Array.isArray(pair) && pair.length === 2 && pair[1] != null) out[String(pair[0])] = String(pair[1]); });
    } else if (typeof p === 'object') {
      Object.keys(p).forEach(function (k) { if (p[k] != null) out[k] = String(p[k]); });
    }
    return Object.keys(out).length ? out : null;
  }

  function matchVariant() {
    return vm.variants.find(function (v) {
      return vm.options.every(function (o, i) { return String(v.options[i]) === String(vm.selected[o.name]); });
    });
  }

  function currentImage() {
    if (vm.manualImg) return vm.manualImg;
    var m = matchVariant();
    var img = imgOf(m);
    if (!img && vm.colorIdx > -1) img = vm.colorImg[vm.selected[vm.options[vm.colorIdx].name]] || '';
    return img || vm.baseImage || '';
  }

  function renderSummary() {
    var m = matchVariant();
    var img = currentImage();
    document.getElementById('obf-vm-image').innerHTML = img ? '<img src="' + img + '" alt="">' : '';
    document.getElementById('obf-vm-title').textContent = vm.baseTitle || '';
    var price = m && typeof m.price === 'number' ? m.price : 0;
    var cmp = m && typeof m.compare_at_price === 'number' ? m.compare_at_price : 0;
    var html = '<span class="obf-vm-now">' + money(price) + '</span>';
    if (cmp && cmp > price) {
      html += '<span class="obf-vm-was">' + money(cmp) + '</span>';
      var pct = Math.round((cmp - price) * 100 / cmp);
      if (pct > 0) html += '<span class="obf-vm-save">Save ' + pct + '%</span>';
    }
    document.getElementById('obf-vm-price').innerHTML = html;
    var btn = document.getElementById('obf-vm-update');
    btn.disabled = !m || (m.available === false);
    btn.textContent = vm.mode === 'add' ? 'Add to cart' : 'Save changes';
  }

  function renderThumbs() {
    var box = document.getElementById('obf-vm-thumbs');
    if (!box) return;
    /* Free-gift lines (e.g. the CloudStep insoles) only carry one photo per
       colour, so the thumbnail strip just repeats the colour swatches shown
       below — the shopper would see each colour twice. Suppress the strip for
       gift lines only; every normal product keeps its full image gallery. */
    if ((vm.isGift && vm.colorIdx > -1) || !vm.images || vm.images.length < 2) { box.innerHTML = ''; return; }
    var active = currentImage();
    var html = '';
    vm.images.forEach(function (src) {
      var on = sameImg(src, active);
      html += '<button type="button" class="obf-vm-thumb' + (on ? ' is-active' : '') + '" data-thumb="' + String(src).replace(/"/g, '&quot;') + '"><img src="' + src + '" alt=""></button>';
    });
    box.innerHTML = html;
  }

  function renderOptions() {
    var html = '';
    vm.options.forEach(function (o, idx) {
      var isColor = idx === vm.colorIdx;
      html += '<div class="obf-vm-optgroup"><div class="obf-vm-optgroup__name">' + o.name + '</div>';
      if (isColor) {
        html += '<div class="obf-vm-swatches">';
        o.values.forEach(function (val) {
          var sel = String(vm.selected[o.name]) === String(val);
          var swImg = vm.colorImg[val] || vm.baseImage || '';
          html += '<button type="button" class="obf-vm-sw' + (sel ? ' is-selected' : '') + '" data-option="' + o.name + '" data-value="' + String(val).replace(/"/g, '&quot;') + '" title="' + String(val).replace(/"/g, '&quot;') + '">' +
            (swImg ? '<img src="' + swImg + '" alt="">' : '<span class="obf-vm-sw__dot"></span>') +
            '<span class="obf-vm-sw__lb">' + val + '</span></button>';
        });
        html += '</div>';
      } else {
        html += '<div class="obf-vm-values">';
        o.values.forEach(function (val) {
          var sel = String(vm.selected[o.name]) === String(val);
          html += '<button type="button" class="obf-vm-val' + (sel ? ' is-selected' : '') + '" data-option="' + o.name + '" data-value="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    document.getElementById('obf-vm-options').innerHTML = html;
  }

  function renderAll() { renderSummary(); renderThumbs(); renderOptions(); }

  function open(btn, mode) {
    vm.mode = mode || 'change';
    vm.isGift = btn.classList.contains('cd-variant-btn--gift');
    vm.itemKey = btn.dataset.itemKey || null;
    vm.qty = parseInt(btn.dataset.quantity, 10) || 1;
    try { vm.variants = JSON.parse(btn.dataset.variants); } catch (e) { vm.variants = []; }
    try { vm.options = JSON.parse(btn.dataset.options); } catch (e) { vm.options = []; }
    if (!vm.variants.length || !vm.options.length) return;
    try { vm.props = vm.mode === 'change' && btn.dataset.properties ? normaliseProps(JSON.parse(btn.dataset.properties)) : null; } catch (e) { vm.props = null; }
    vm.baseTitle = btn.dataset.title || '';
    vm.baseImage = btn.dataset.image || '';
    vm.images = (btn.dataset.images || '').split('|').filter(Boolean);
    vm.manualImg = null;
    vm.selectedId = parseInt(btn.dataset.variantId || btn.dataset.addId, 10);

    vm.colorIdx = -1;
    vm.options.forEach(function (o, i) { if (/colou?r/i.test(o.name)) vm.colorIdx = i; });

    vm.colorImg = {};
    if (vm.colorIdx > -1) {
      vm.variants.forEach(function (v) {
        var c = v.options[vm.colorIdx];
        var im = imgOf(v);
        if (c != null && im && !vm.colorImg[c]) vm.colorImg[c] = im;
      });
    }

    var current = vm.variants.find(function (v) { return v.id == vm.selectedId; }) ||
      vm.variants.find(function (v) { return v.available; }) || vm.variants[0];
    vm.selected = {};
    vm.options.forEach(function (o, i) { vm.selected[o.name] = current.options[i]; });

    renderAll();
    document.getElementById('obf-variant-modal').classList.add('is-open');
  }

  function close() {
    document.getElementById('obf-variant-modal').classList.remove('is-open');
    vm = { mode: 'change', itemKey: null, qty: 1, variants: [], options: [], colorIdx: -1, colorImg: {}, images: [], manualImg: null, selected: {}, selectedId: null, baseTitle: '', baseImage: '', props: null, isGift: false };
  }

  /* delegated: open modal, pick option, pick thumb, close, carousel/review nav */
  document.addEventListener('click', function (e) {
    var changeBtn = e.target.closest('.cd-variant-btn');
    if (changeBtn) { open(changeBtn, 'change'); return; }

    var recAdd = e.target.closest('.obf-rec-card__add');
    if (recAdd && !recAdd.disabled) {
      var rv = [];
      try { rv = recAdd.dataset.variants ? JSON.parse(recAdd.dataset.variants) : []; } catch (err) { rv = []; }
      if (rv.length > 1) { open(recAdd, 'add'); } else { directAdd(recAdd.dataset.addId, recAdd); }
      return;
    }

    if (e.target.closest('[data-obf-vm-close]')) { close(); return; }

    var thumb = e.target.closest('.obf-vm-thumb');
    if (thumb) { vm.manualImg = thumb.dataset.thumb || null; renderSummary(); renderThumbs(); return; }

    var pick = e.target.closest('.obf-vm-sw, .obf-vm-val');
    if (pick) { vm.selected[pick.dataset.option] = pick.dataset.value; vm.manualImg = null; renderAll(); return; }

    var recNav = e.target.closest('.obf-recs__nav');
    if (recNav) {
      var vp = recNav.closest('.obf-recs__viewport');
      var track = vp && vp.querySelector('.obf-recs__track');
      if (track) {
        var dir = parseInt(recNav.dataset.obfRecDir, 10) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      return;
    }

    var revNav = e.target.closest('.obf-reviews__nav');
    if (revNav) {
      var rbox = revNav.closest('.obf-reviews');
      if (rbox && rbox.__obfShow) {
        rbox.__obfShow(rbox.__obfIdx + (parseInt(revNav.dataset.obfRevDir, 10) || 1));
        if (rbox.__obfTimer) { clearInterval(rbox.__obfTimer); rbox.__obfTimer = setInterval(function () { rbox.__obfShow(rbox.__obfIdx + 1); }, 4500); }
      }
      return;
    }
  });

  /* Save / Add */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#obf-vm-update')) return;
    var m = matchVariant();
    if (!m) return;
    var btn = document.getElementById('obf-vm-update');
    btn.disabled = true;
    btn.textContent = vm.mode === 'add' ? 'Adding...' : 'Updating...';

    if (vm.mode === 'add') {
      var addBody = { id: m.id, quantity: 1 };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(addBody) })
        .then(refreshDrawer)
        .then(close)
        .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
      return;
    }

    if (!vm.itemKey) { close(); return; }
    /* change = remove old line, add new variant. The line's ORIGINAL quantity and
       properties carry over (quantity used to be hard-coded to 1 — changing the
       color of a 2-pair line silently dropped it to 1 pair). If every add attempt
       fails (e.g. the new variant just sold out), the original line is restored
       so the shopper never loses their item. */
    var newQty = vm.qty || 1;
    var origVariantId = vm.selectedId;
    var origProps = vm.props;
    var body = { id: m.id, quantity: newQty };
    if (origProps && Object.keys(origProps).length) body.properties = origProps;
    var restoreBody = { id: origVariantId, quantity: newQty };
    if (origProps && Object.keys(origProps).length) restoreBody.properties = origProps;
    window.__obf_modal_updating = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vm.itemKey, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); })
      .then(function (r) {
        if (r && r.ok === false) {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: m.id, quantity: newQty }) });
        }
        return r;
      })
      .then(function (r) {
        if (r && r.ok === false) {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(restoreBody) });
        }
        return r;
      })
      .then(refreshDrawer)
      .then(close)
      .catch(function () { btn.textContent = 'Save changes'; btn.disabled = false; })
      .then(function () {
        window.__obf_modal_updating = false;
        if (window.OBFCartGuard && window.OBFCartGuard.validate) setTimeout(window.OBFCartGuard.validate, 60);
      });
  });

  document.addEventListener('DOMContentLoaded', function () { window.initRecommendationTracks(); });
  if (document.readyState !== 'loading') window.initRecommendationTracks();
})();
